import { store as storeLinkGroupEvent } from '@/routes/internal-api/link-group-events';

type LinkGroupEventType = 'button_click' | 'property_click';

type TrackPayload = {
  type: LinkGroupEventType;
  section_type?: string | null;
  section_id?: string | null;
  metadata?: Record<string, string>;
};

/**
 * Fire-and-forget engagement tracking for the public "link in bio" page. Uses
 * `navigator.sendBeacon` so events survive the page unload that follows a click
 * on an outbound link.
 */
export default function useLinkGroupTracking(linkGroupId: string) {
  const track = (payload: TrackPayload): void => {
    const url = storeLinkGroupEvent({ linkGroup: linkGroupId }).url;
    const body = new Blob([JSON.stringify(payload)], { type: 'application/json' });

    if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
      navigator.sendBeacon(url, body);

      return;
    }

    void fetch(url, {
      method: 'POST',
      body,
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
    });
  };

  return { track };
}
